import { render, staticRenderFns } from "./TableListing.vue?vue&type=template&id=52afbdc8"
import script from "./TableListing.vue?vue&type=script&lang=js"
export * from "./TableListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports